var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgregartarjeta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 20H10.5C6.741 20 4.862 20 3.607 19.01C3.40756 18.852 3.2222 18.677 3.053 18.487C2 17.307 2 15.537 2 12C2 8.463 2 6.694 3.053 5.513C3.22167 5.32367 3.40633 5.14967 3.607 4.991C4.862 4 6.741 4 10.5 4H13.5C17.259 4 19.138 4 20.392 4.99C20.5933 5.15 20.7783 5.32433 20.947 5.513C21.839 6.513 21.976 7.936 21.997 10.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 20V13M15 16.5H22",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 9H22",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgregartarjeta);
export default __webpack_public_path__ + "static/media/agregartarjeta.1d336e32e08becb777fb796e405aeba9.svg";
export { ForwardRef as ReactComponent };